import React, { useMemo } from 'react';
import { Layout } from 'antd';
import { ContainerPanel, CompsTable, ContainerModal, CompsForm } from '@ms/shared-components';
import ConfigTree from './components/ConfigTree';
import { useDatasetConfig } from './hooks/useDatasetConfig';
import {
  getFormItems,
  getColumns,
  getTreePanelButtons,
  getTablePanelButtons,
  tableConfig,
  modalConfig,
  getModalFooterButtons,
  getModalTitle,
  formConfig,
} from './config';
import { getFormInitialValues } from './utils';
import '../shared/ai-config.css';

const { Sider, Content } = Layout;

const DatasetPage: React.FC = () => {
  const {
    datasets,
    treeData,
    loading,
    modalVisible,
    editingRecord,
    setFormRef,
    loadDatasets,
    loadTreeData,
    handleSelect,
    handleOpenModal,
    handleCloseModal,
    handleSave,
    handleDelete,
    expandedKeys,
    selectedKeys,
    setExpandedKeys,
  } = useDatasetConfig();

  const formItems = useMemo(
    () => getFormItems(editingRecord),
    [editingRecord]
  );
  const columns = useMemo(
    () => getColumns(handleOpenModal, handleDelete),
    [handleOpenModal, handleDelete]
  );
  const initialValues = useMemo(
    () => getFormInitialValues(editingRecord),
    [editingRecord]
  );
  const treeButtons = useMemo(
    () =>
      getTreePanelButtons({
        onRefresh: loadTreeData,
        onCreate: () => handleOpenModal(),
      }),
    [loadTreeData, handleOpenModal]
  );
  const tableButtons = useMemo(
    () => getTablePanelButtons({ onRefresh: loadDatasets }),
    [loadDatasets]
  );
  const footerButtons = useMemo(
    () => getModalFooterButtons(handleCloseModal, handleSave),
    [handleCloseModal, handleSave]
  );
  const modalTitle = useMemo(
    () => getModalTitle(!!editingRecord),
    [editingRecord]
  );

  return (
    <div style={{ height: '100vh', overflow: 'hidden' }}>
      <Layout style={{ height: '100%', display: 'flex', gap: 16, backgroundColor: '#fff' }}>
        <Sider
          width={400}
          style={{
            background: '#fff',
            borderRight: '1px solid #f0f0f0',
            overflow: 'hidden',
            display: 'flex',
            flexDirection: 'column',
            flexShrink: 0,
          }}
        >
          <ContainerPanel title="关系树" buttons={treeButtons} height={'100%'}>
            <ConfigTree
              treeData={treeData}
              selectedKeys={selectedKeys}
              expandedKeys={expandedKeys}
              onSelect={handleSelect}
              onExpand={setExpandedKeys}
              onAddNode={() => {}}
            />
          </ContainerPanel>
        </Sider>
        <Content
          style={{
            overflow: 'auto',
            backgroundColor: '#fff',
            height: '100%',
          }}
        >
          <ContainerPanel title="数据集列表" buttons={tableButtons} height={'100%'}>
            <CompsTable
              resizableColumns
              storageKey="msai-dataset"
              tableProps={{
                columns: columns as any,
                dataSource: datasets,
                rowKey: tableConfig.rowKey,
                loading,
                scroll: { x: 1200 },
                pagination: tableConfig.pagination,
              } as any}
            />
          </ContainerPanel>
        </Content>
      </Layout>

      <ContainerModal
        title={modalTitle}
        visible={modalVisible}
        onCancel={handleCloseModal}
        width={modalConfig.width}
        height={modalConfig.height}
        contentPadding={modalConfig.contentPadding}
        footerRightButtons={footerButtons}
        modalProps={modalConfig.modalProps}
      >
        <CompsForm
          formItems={formItems}
          formRef={setFormRef}
          initialValues={initialValues}
          layout={formConfig.layout}
          contentPadding={formConfig.contentPadding}
        />
      </ContainerModal>
    </div>
  );
};

export default DatasetPage;
